import { Integer } from '@type-r/ext-types';
import { attributes, define, type } from '@type-r/models';
import { restfulIO } from 'api/endpoint';
import { root } from './common'

export const InmatchOrg = {
    name : String,
    shortName : String,
    inblockId : String,
    externalRelationshipId : String,
    companyLegalEntityId : String,
    parentName : String,
};

export const CustomerInmatchOrg = attributes({
    ...InmatchOrg,
    eRP : String,
    mainSegment : String,
    oLS : String,
    fDSS : String
});

export type CustomerInmatchOrg = typeof CustomerInmatchOrg;

export const SupplierInmatchOrg = attributes({
    ...InmatchOrg,
    region : String,
    gBSUnit : String,
    externalId : String,
    mep : String,
    subMep : String
});

export type SupplierInmatchOrg = typeof SupplierInmatchOrg;

@define
export class InmatchConversation extends
    attributes({
        conversationId : type( Integer ).value( undefined ),
        workflowMapId : Integer,
        customer : CustomerInmatchOrg,
        supplier : SupplierInmatchOrg,
        supplierId : String,
        customerId : String, 
    })
{
    static endpoint = restfulIO( root + 'relationship/conversations');
    static idAttribute = "conversationId";
}

export const ConversationMixin = {
    get conversation() : InmatchConversation {
        const conversation = this.getStore().conversations.get( this.conversationId );
        return conversation || new InmatchConversation({ conversationId : this.conversationId });
    }
}

export type ConversationMixin = typeof ConversationMixin;
